import { render, staticRenderFns } from "./SearchAmountModal.vue?vue&type=template&id=21492cb9&"
import script from "./SearchAmountModal.vue?vue&type=script&lang=ts&"
export * from "./SearchAmountModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports